import sortBy from 'lodash/sortBy'
import { VEHICLE_TYPES, NATIONS_BY_REALM } from 'constants'

export function isVehicleReadyForBattle(vehicle) {
    if (!vehicle) return false

    if (vehicle.readiness && !vehicle.readiness.isReady) return false

    return true
}

export function filterVehicles(allVehicles, filter) {
    return allVehicles.filter(vehicle => {
        if (filter.onlyFavorite && !vehicle.isFavorite) return false

        if (filter.nation !== 'all_nations' && vehicle.nation !== filter.nation) return false

        if (filter.vehicleTypes.length > 0 && !filter.vehicleTypes.includes(vehicle.type)) return false

        return true
    })
}

export function sortVehicles(vehicles, column, realm, desc, selectedVehicleCds) {
    const selectedSorter = vehicle => !selectedVehicleCds.includes(vehicle.id)
    const nameSorter = vehicle => vehicle.shortName
    const nationSorter = vehicle => NATIONS_BY_REALM[realm].indexOf(vehicle.nation)
    const typeSorter = vehicle => VEHICLE_TYPES.indexOf(vehicle.type)

    const sortersByColumn = {
        checked: [selectedSorter, nationSorter, typeSorter],
        name: [nameSorter, nationSorter, typeSorter],
        nation: [nationSorter, typeSorter, nameSorter],
        type: [typeSorter, nationSorter, nameSorter],
    }

    let sortedVehicles = sortBy(vehicles, sortersByColumn[column])
    return desc ? sortedVehicles.reverse() : sortedVehicles
}

export const getSelectedVehicleCds = (vehicles, selectedVehicleCds) => {
    if (!selectedVehicleCds) return vehicles.map(vehicle => vehicle.id)

    return vehicles
        .filter(vehicle => selectedVehicleCds.includes(vehicle.id))
        .map(vehicle => vehicle.id)
}



// WEBPACK FOOTER //
// ./helpers/vehicles.js